(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricWithNoActiveProcessController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
    }
})();